import React from 'react';

const Spacer: React.FC = () => {
  return (
    <div className="leading-64" role="separator">
      &zwnj;
    </div>
  );
};

export default Spacer;
